import { ClickAwayListener, TextField } from "@mui/material";
import React from "react";
import ReactDraggable from "react-draggable";

import styled from "styled-components";
import { HTMLUtilities } from "../../../CommonUI/HTMLUtilities";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { StateManager } from "../../../rule-engine-core/Common/StateManager";
import { FlowEditContext } from "../../FlowEditContext";
import { FlowStepSequence } from "../../../rule-engine-core/Flow/Structure/FlowStepSequence";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

const SequenceForErrorMessageDiv = styled.div<{ width: number }>`
    position: absolute;
    background: ${UIStyleConstants.GRAY_LIGHT_COLOR};
    width: ${(props) => props.width}px;

    .MuiOutlinedInput-input {
        padding: 6px 12px;
        color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
    }

    .MuiOutlinedInput-notchedOutline {
        border: 1px solid ${UIStyleConstants.GRAY_LIGHTER_COLOR};
        box-sizing: border-box;
        border-radius: 4px;
    }
`;

interface IErrorMessageForSequence {
    editContext: FlowEditContext;
}

export const ErrorMessageForSequence: React.FC<IErrorMessageForSequence> = (props: IErrorMessageForSequence) => {
    function onUnSelectSequenceForErrorMessage() {
        props.editContext.selectedSequenceForError = null;
    }

    return (
        <ObserveState
            listenTo={props.editContext}
            properties={[FlowEditContext.SELECTED_SEQUENCE_FOR_ERROR]}
            control={() => {
                if (!props.editContext.selectedSequenceForError) {
                    return <></>;
                }
                let { sequence, position } = props.editContext.selectedSequenceForError;

                let pos = HTMLUtilities.getGeometry(sequence._id);
                return (
                    <ClickAwayListener onClickAway={onUnSelectSequenceForErrorMessage}>
                        <ReactDraggable defaultPosition={position}>
                            <SequenceForErrorMessageDiv
                                width={pos?.width || props.editContext.getSequenceWidth(sequence)}
                            >
                                <ObserveState
                                    listenTo={sequence}
                                    properties={[FlowStepSequence.ERROR_MESSAGE]}
                                    control={() => (
                                        <TextField
                                            data-testid="sequence-strategy_set_errormessage"
                                            value={sequence.errorMessage}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                sequence.errorMessage = event.target.value;
                                                StateManager.propertyChanged(sequence, FlowStepSequence.ERROR_MESSAGE);
                                            }}
                                            variant="outlined"
                                            fullWidth
                                        />
                                    )}
                                />
                            </SequenceForErrorMessageDiv>
                        </ReactDraggable>
                    </ClickAwayListener>
                );
            }}
        />
    );
};
